export default __webpack_public_path__ + "static/media/menu1.de21b81a.svg";